export function getRtlFlipStyle(): { transform?: string } {
  return {
    transform: document.dir === "rtl" ? "rotate(180deg)" : undefined,
  };
}
